export class OrderingItemCategory {
    categoryName: string;
    sequence: number;
}
